// extracted by mini-css-extract-plugin
export var content = "Participation-module--content--af801";
export var infoCard = "Participation-module--infoCard--bb03c";
export var infoText = "Participation-module--infoText--b53c8";
export var mainTitle = "Participation-module--mainTitle--3a664";
export var participationSection = "Participation-module--participationSection--63552";